import apiConfig from '../config/api';

const { apiBaseUrl } = apiConfig;

const FormService = {
  submitForm: async (source, data) => {
    try {
      const response = await fetch(`${apiBaseUrl}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          source,
          data
        }),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      return await response.json();
    } catch (error) {
      console.error('Error submitting form:', error);
      // We might want to throw here or return a standardized error object
      // For now, we'll return success: false to handle it gracefully in UI
      return { success: false, error: error.message };
    }
  }
};

export default FormService;

